import React from 'react';
import { styled } from '@compiled/react';
import PeopleIcon from '@atlaskit/icon/glyph/people';
import RoadmapIcon from '@atlaskit/icon/glyph/roadmap';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { AiIcon as AtlassianIntelligenceIcon } from '@atlassian/jira-atlassian-intelligence';
import { useIntl } from '@atlassian/jira-intl';
import { AutomationIcon } from './assets/automation-icon';
import messages from './messages';

const FALLBACK_COLOR = '#0055CC';

export const BenefitsList = () => {
	const { formatMessage } = useIntl();
	const listItems = [
		{
			icon: <RoadmapIcon primaryColor={token('color.link.pressed', FALLBACK_COLOR)} label="" />,
			header: messages.crossTeamHeadingComplexspork,
			description: messages.crossTeamDescriptionComplexspork,
		},
		{
			icon: <AtlassianIntelligenceIcon size="medium" label="" />,
			header: messages.aiHeadingComplexspork,
			description: messages.aiFeaturesDescriptionComplexspork,
		},
		{
			icon: <AutomationIcon primaryColor={token('color.link.pressed', FALLBACK_COLOR)} label="" />,
			header: messages.higherAutomationHeadingComplexspork,
			description: messages.higherAutomationDescriptionComplexspork,
		},
		{
			icon: <PeopleIcon primaryColor={token('color.link.pressed', FALLBACK_COLOR)} label="" />,
			header: messages.greaterAdminControlsHeadingComplexspork,
			description: messages.muchMoreDescriptionComplexspork,
		},
	];
	return (
		<List>
			{listItems.map((item, index) => (
				<ListItem key={index}>
					<IconBox>{item.icon}</IconBox>
					<Box xcss={contentContainerStyles}>
						<Header>{formatMessage(item.header)}</Header>
						<Content>{formatMessage(item.description)}</Content>
					</Box>
				</ListItem>
			))}
		</List>
	);
};

export default BenefitsList;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const List = styled.ul({
	marginTop: token('space.300', '24px'),
	padding: token('space.0', '0px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Header = styled.p({
	fontWeight: '700',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ListItem = styled.li({
	display: 'flex',
	gap: token('space.200', '16px'),
	justifyContent: 'flex-start',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconBox = styled.div({
	alignItems: 'center',
	backgroundColor: token('color.background.accent.blue.subtlest', '#E9F2FF'),
	borderRadius: token('border.radius.200', '8px'),
	display: 'flex',
	height: token('space.500', '40px'),
	justifyContent: 'center',
	marginTop: token('space.050', '4px'),
	minHeight: token('space.500', '40px'),
	minWidth: token('space.500', '40px'),
	width: token('space.500', '40px'),
});

const contentContainerStyles = xcss({
	marginBottom: 'space.300',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Content = styled.p({
	marginTop: token('space.0', '0px'),
});
